import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ApiConfigurationInterceptor } from './api-configuration/api-configuration.interceptor';
import { MessagesInterceptor } from './messages/messages.interceptor';
import { LoaderInterceptor } from './loader/loader.interceptor';
import { TokenInterceptor } from './token/token.interceptor';

export const interceptorsProvider = [
  { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ApiConfigurationInterceptor,
    multi: true
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: MessagesInterceptor,
    multi: true
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: LoaderInterceptor,
    multi: true
  }
];
